module.exports = __webpack_public_path__ + "img/grand-restaurant.f2d465b1.jpg";